import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import clsx from "clsx";

const PetSpecies: React.FC<{ className?: string; petSpeciesId: string; variant: "DEFAULT" | "INE" }> = ({
  petSpeciesId,
  className,
}) => {

  const { pet_species } = useArrayConstants()

  let speciesName = "";
  const petSpeciesFiltered = pet_species && pet_species?.filter((p) => p.id === petSpeciesId);

  if (petSpeciesFiltered?.length > 0) {
    speciesName = petSpeciesFiltered[0]?.title;
  } else {
    speciesName = "Other";
  }
  return <p className={clsx("text-[10px] sm:text-xs", className)}>{speciesName}</p>;
};

export default PetSpecies;
